export default __webpack_public_path__ + "0d43167d8922577a3c119e961d43a6a8.svg";